import moment from 'moment';

function debounce(func, wait, immediate) {
	let timeout, args, context, timestamp, result;

	const later = function() {
		const last = +new Date() - timestamp;

		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last);
		} else {
			timeout = null;
			if (!immediate) {
				result = func.apply(context, args);
				context = args = null;
			}
		}
	};

	return function(...args) {
		context = this;
		timestamp = +new Date();
		const callNow = immediate && !timeout;
		if (!timeout) timeout = setTimeout(later, wait);
		if (callNow) {
			result = func.apply(context, args);
			context = args = null;
		}

		return result;
	};
}

const unique = arr => {
	const res = [];
	const json = {};
	for (let i = 0; i < arr.length; i++) {
		if (!json[arr[i]]) {
			res.push(arr[i]);
			json[arr[i]] = 1;
		}
	}
	return res;
};

const queryParam = params => {
	if (!params) return '';
	return Object.keys(params).filter(el => params[el]).map(key => key + '=' + params[key]).join('&');
};

const dateToString = (date, format = 'DD-MM-YYYY HH:mm:ss') => {
	if (!date) return '';
	return moment(date).format(format);
};

const currencyVND = (value) => {
	if (!value) return '0 VND';
	return value.toLocaleString('it-IT', { style: 'currency', currency: 'VND' });
};

/**
 * Đệ quy để tìm hierarchy của path từ menus
 * @param {Array} menus - danh sách menu
 * @param {String} targetPath - path con cần tìm
 * @returns {Array} - danh sách title từ cha đến con
 */
const findPathHierarchy = (menus, targetPath) => {
	for (const item of menus) {
		let isDynamic = false;
		let id = null;
		if (item.path?.includes(':id')) {
			isDynamic = true;
			const arrPath = targetPath.split('/');
			id = `${item.path.replaceAll(':id', '')}${arrPath[arrPath.length - 1]}`;
		}
		// Nếu item khớp path
		if (item.path === targetPath || (isDynamic && id === targetPath)) {
			return [{ path: item.path, icon: item.icon, title: item.title }];
		}
		// Nếu có children, tìm trong children
		if (item.children) {
			const childPath = findPathHierarchy(item.children, targetPath);
			if (childPath.length) {
				return [{ path: item.path, icon: item.icon, title: item.title }, ...childPath];
			}
		}
	}

	return [];
};

const convertArrayToObject = (array) => {
	return array.reduce((acc, item) => {
		acc[item.value] = item.name;
		return acc;
	}, {});
};

const formatCurrency = (value = 0) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const parserNumber = (value = 0) => value.replace(/\$\s?|(,*)/g, '');


export {
	unique,
	debounce,
	queryParam,
	dateToString,
	currencyVND,
	findPathHierarchy,
	convertArrayToObject,
	formatCurrency,
	parserNumber
};

